import { OrganizedScorecardRow } from "./database-export";

const fieldAliases: Record<string, keyof OrganizedScorecardRow> = {
  uid: "uid",
  year: "financialYear",
  financialyear: "financialYear",
  type: "recordType",
  name: "name",
  department: "department",
  section: "section",
  goal: "strategicGoal",
  objective: "objective",
  measure: "measure",
  perspective: "perspective",
  status: "reviewStatus",
};

const contains = (value: unknown, query: string) =>
  String(value ?? "").toLocaleLowerCase().includes(query.toLocaleLowerCase());

export const queryOrganizedScorecards = (
  rows: OrganizedScorecardRow[],
  query: string
) => {
  const input = query.trim();
  if (!input) return rows;

  let results = rows;
  const select = input.match(/^select\s+(\*|users?|departments?|company|goals?|objectives?|measures?)/i)?.[1]?.toLowerCase();
  if (select && select !== "*") {
    if (select.startsWith("user")) results = results.filter((row) => row.recordType.startsWith("User"));
    else if (select.startsWith("department")) results = results.filter((row) => row.recordType === "Department");
    else if (select === "company") results = results.filter((row) => row.recordType.startsWith("Company"));
    else if (select.startsWith("goal")) results = results.filter((row) => row.recordType === "Strategic Goal");
    else if (select.startsWith("objective")) results = results.filter((row) => row.recordType.includes("Objective"));
    else if (select.startsWith("measure")) results = results.filter((row) => row.recordType.includes("Measure"));
  }

  const conditionPattern = /\b(uid|year|financialyear|type|name|department|section|goal|objective|measure|perspective|status)\s*(?:=|:)\s*(?:"([^"]+)"|'([^']+)'|([^\s]+))/gi;
  const conditions: Array<{ field: keyof OrganizedScorecardRow; value: string }> = [];
  let match: RegExpExecArray | null;
  while ((match = conditionPattern.exec(input)) !== null) {
    conditions.push({ field: fieldAliases[match[1].toLowerCase()], value: match[2] || match[3] || match[4] });
  }

  const fromUid = input.match(/\bfrom\s+uid\s+(?!where\b)(?:=\s*)?(?:"([^"]+)"|'([^']+)'|([^\s]+))/i);
  if (fromUid) conditions.push({ field: "uid", value: fromUid[1] || fromUid[2] || fromUid[3] });

  if (conditions.length) {
    return results.filter((row) => conditions.every(({ field, value }) => contains(row[field], value)));
  }

  const plainSearch = input
    .replace(/^select\s+(\*|users?|departments?|company|goals?|objectives?|measures?)/i, "")
    .replace(/\b(from|where|data|table|uid)\b/gi, "")
    .trim();
  if (!plainSearch) return results;

  return results.filter((row) => Object.values(row).some((value) => contains(value, plainSearch)));
};
